import Container from 'components/layout/Container';
import CarouselSwiper from 'components/carousel/CarouselSwiper';
import { RecipeListingData } from 'lib/contentful/types';
import CarouselRecipeCard from 'components/card/CarouselRecipeCard';
import NextLink from 'next/link';
import frontendConfig from 'config/frontend-config';

interface RecipesCarouselProps {
  recipes: RecipeListingData[];
}

const RecipesCarousel: React.FC<RecipesCarouselProps> = (props) => {
  const { recipes } = props;

  return (
    <>
      <div className="relative w-full overflow-hidden text-sf-blue-700 print:hidden">
        <Container>
          <div className="relative w-full py-5 md:py-10">
            <div className="relative w-full pb-4">
              <div className="pb-2">
                <div className="relative flex w-full items-center justify-between">
                  <div>
                    <h4 className="text-3xl uppercase">More recipes</h4>
                  </div>
                  <NextLink href={frontendConfig.recipesUrlSlug} passHref>
                    <a target={'_self'} className="text-base font-medium uppercase">
                      View all
                    </a>
                  </NextLink>
                </div>
              </div>
            </div>
            <CarouselSwiper length={recipes.length}>
              {recipes.map((recipe) => {
                return (
                  <CarouselRecipeCard key={recipe.sys.id} recipe={recipe}></CarouselRecipeCard>
                );
              })}
            </CarouselSwiper>
          </div>
        </Container>
      </div>
    </>
  );
};

export default RecipesCarousel;
